import { api } from "../../api/http";

const BASE = "/api/backoffice/recorded-classes/";

export async function listRecordedClasses(params = {}) {
	const res = await api.get(BASE, { params });
	return res.data;
}

export async function createRecordedClass(payload) {
	const res = await api.post(BASE, payload);
	return res.data;
}

export async function updateRecordedClass(id, payload) {
	const res = await api.patch(`${BASE}${id}/`, payload);
	return res.data;
}

export async function deleteRecordedClass(id) {
	const res = await api.delete(`${BASE}${id}/`);
	return res.data;
}
